<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-washing-machine`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4a1 1 0 011 1v38a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1h32zm-3 12H11v24h26V16zm-4 12a9 9 0 10-18 0 9 9 0 0018 0zm-9-5a5 5 0 100 10 5 5 0 000-10zM11 8h26v4H11V8z"/></svg>
</template>
<script>

export default {
  name: 'IconWashingMachine',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
